import PropTypes from 'prop-types'
import React from 'react'
import SpanBotoesCookiesBanner, {
  DivCookiebanner, ContainerCookieBanner,
  TituloCookieBanners, ContainerConteudoDivBanner, TextoCookieBanner, Botao,
} from '../UtilsEstilo'
import { salvarCookies } from '../Funcoes'

function CookieBanner({ visivel, usuarioAceitou }) {
  return (
    <ContainerCookieBanner>
      <DivCookiebanner visivel={visivel}>
        <TituloCookieBanners>PRIVACIDADE</TituloCookieBanners>
        <ContainerConteudoDivBanner>
          <TextoCookieBanner>
            Usamos cookies e tecnologias semelhantes para uma melhor experiência de navegação.
            Ao clicar em Aceitar, você concorda com isso.
          </TextoCookieBanner>
          <SpanBotoesCookiesBanner>
            <Botao
              type="button"
              value="Aceitar"
              onClick={() => salvarCookies(usuarioAceitou)}
            />
          </SpanBotoesCookiesBanner>
        </ContainerConteudoDivBanner>
      </DivCookiebanner>
    </ContainerCookieBanner>
  )
}
CookieBanner.propTypes = {
  visivel: PropTypes.bool,
  usuarioAceitou: PropTypes.func,
}
CookieBanner.defaultProps = {
  visivel: PropTypes.false,
  usuarioAceitou: undefined,
}
export default CookieBanner
